import React from 'react';
import NotFound from '@/components/common/NotFound';
import { useLocation } from 'react-router-dom';

const isDev = process.env.NODE_ENV === 'development';
const isWebView =
    typeof window !== 'undefined' &&
    window?.ReactNativeWebView &&
    typeof window?.ReactNativeWebView?.postMessage === 'function';

export default function ProtectedRoute({ children }) {
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const admin = query.get('admin');
    const isAdmin = admin === 'zjacotrhksflwk';
    return isAdmin || isDev || isWebView ? children : <NotFound />;
}
